import { ProposalRejectionReasonComponent } from 'src/app/commonUI/proposal-rejection-reason/proposal-rejection-reason.component';
import { AppSettings } from './../../../app.settings';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QueryPartInfoSearchByPartNumberDTO } from 'src/app/models/internal/query-partInfo-searchby-partnumber-dto';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { Constants } from 'src/app/core/constants';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from 'src/app/services/form';
import { DataService } from 'src/app/services/data.service';
import { ProposalService } from 'src/app/services/proposal.service';
import { of } from 'rxjs';
import { ProposalBasicInfoDTO } from 'src/app/models/internal/proposal-basicInfo-dto';
import { QueryPartProposalsSearchDTO } from 'src/app/models/internal/query-partproposals-search-dto';
import { DatePipe } from '@angular/common';
import * as moment from 'moment/moment';
import Helper from 'src/app/core/utility/helper';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { PackageType } from 'src/app/models/packagetype';
import { QueryPendingProposalDTO } from 'src/app/models/internal/query-pendingproposal-dto';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { PartInfo } from 'src/app/models/partinfo';
import { NGXLogger } from 'ngx-logger';
import UIHelper from 'src/app/core/utility/ui-helper';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { UserPermissions } from 'src/app/permissions';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-search-part-pe',
  templateUrl: './search-part-pe.component.html',
  styleUrls: ['./search-part-pe.component.scss']
})
export class SearchPartPeComponent extends BaseGridPage
    implements OnInit, AfterViewInit, ICanExportData {
    partNumber: string = "";
    sourceTypeId: string = "";;
    supplierCode: string = "";;
    excelFilenamePrefix = "SearchPartResults_PE_";
    appSettings: AppSettings;
    searchPartForm: FormGroup;
    locStorage = Constants.localStorageKeys;
    partList: PartBasicInfo[];
    partSystemList: PartSystemDTO[];
    proposalList: ProposalBasicInfoDTO[];
    sourceTypeList: SourceType[];
    packageTypeList:  PackageType[];
    childControlTooltipText: string = '';
    atLeastOneFieldError: boolean = false;
    isMarkedHotRequestList: any[] = [];
    pipe = new DatePipe('en-US');
    searchClicked = false;
    getProposalClicked = false;
    partFound = false;
    HasReviewProposalWritePermission: boolean = false;

    // sourcePartInfoId: number;
    public formErrors = {
        partNumberToSearch: '',
        SourceTypeId: '',
        PartCategoryId: '',
        PackageTypeId: '',
        TeslaEquipmentCode: '',
        WorkflowStatusId: ''
    };
    filterForm: FormGroup;
    approvedStatus: number = Constants.WORKFLOW_STATUS_APPROVED;
    newStatus: number = Constants.WORKFLOW_STATUS_NEW;
    autoCompletePEURL: string ;
    searchSupplierURL: string ;
    partInfoInContext: PartBasicInfo; // part for which proposals are currently viewed.
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    Demand_Status = [{ text: 'Past', value: 'P' }, { text: 'Future', value: 'F' }, { text: 'Current', value: 'C' }, { text: 'No Demand', value: 'N' }];
    WorkflowStatusId = [{ text: 'Submitted', value: 2 }, { text: 'Approved', value: 4 },{ text: 'Pending Validation', value: 5 }, { text: 'Incomplete', value: 6 }, { text: 'Rejected', value: 3 }];

    constructor(
        localstorageService: LocalstorageService,
        private toastService: ToastService,
        private readonly route: ActivatedRoute,
        private router: Router,
        private FormService: FormService,
        logger: NGXLogger,
        appSettings: AppSettings,
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        private matDialog: MatDialog
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
          PartNumber: [null],
            PartDescription: [null],
          SupplierCode: [null],
          SourceTypeId: [null],
          PartCategoryId: [null],
          HotRequest: [null],
          AtLeastOneFilter: [null],
          EngineerUserId: [null],
          PackageTypeId: [null],
          Demand_Status: [null],
          WorkflowStatusId: [null],
          TeslaEquipmentCode: [null]
        });
        this.isMarkedHotRequestList.push({ Description: 'Yes', Value: true });
        this.isMarkedHotRequestList.push({ Description: 'No', Value: false });
        this.appSettings = appSettings;
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.partNumber =  params['pn'];
            this.sourceTypeId =  params['st'];
            this.supplierCode =  params['sc'];
          });
       
        this.getSourceTypes();
        this.getPartSystems();
        this.getPackageTypes();
        this.initFilterValues();
        this.HasReviewProposalWritePermission = Helper.CheckPermission(this.localstorageService, UserPermissions.Packaging_ReviewProposal_Write);
        if(this.partNumber || this.sourceTypeId || this.supplierCode)
        {
            this.UpdateFilterFromQueryString();
            this.localSearch();
        }
    }

    getPartNumberToSearch() {
        let partNumber: string = this.searchPartForm.controls[
            'partNumberToSearch'
        ].value;
        if (partNumber) {
            partNumber = partNumber.trim();
        }
        return partNumber;
    }
    fillGrid(): void {
        this.partList = [];
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.getProposalClicked = false;
        const queryPendingProposalDTO: QueryPendingProposalDTO = {
          SearchFilter: this.filter,
          HotRequest: null,
      };
        this.getParts(queryPendingProposalDTO);
    }
    exportData()
    {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        const queryPendingProposalDTO: QueryPendingProposalDTO = {
            SearchFilter: this.filter,
            HotRequest: null,
        };

        this.dataService      
        .getAllPartsForPEExcel(queryPendingProposalDTO)
        .subscribe((response: any) => {
            if (response != null && response.Success) {
                UIHelper.DownloadExcelFile(response.Data, filename);
            } else {
                this.toastService.error(
                    'Could not export data'
                );
            }
        });
    }
    getSourceTypes() {
      this.dataService.getParentSourceTypes().subscribe((response: any) => {
          if (response && response.Data != null) {
              this.sourceTypeList = response.Data;
          }
      });
  }

  getPartSystems() {
      this.dataService.getPartSystems().subscribe((response: any) => {
              if (response != null && response.Success) {
                  this.partSystemList = response.Data;
                  // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
              }
          });
  }

    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            if (response && response.Success) {
                this.packageTypeList = response.Data;
            }
        })
    }

    getParts(queryPendingProposalDTO: QueryPendingProposalDTO) {
      if (this.searchClicked) {
          // this.ValidatesearchPartForm();
          // if (!this.searchPartForm.valid) {
          //     return false;
          // }
      }
    //   this.initiateState();
    //   let partNumberToSearch = this.getPartNumberToSearch();
      this.UpdateFilter();
      this.dataService
          .getAllPartsForPE(queryPendingProposalDTO)
          .subscribe((response: any) => {
              // this.partInfo = response
              if (response != null ) {
                  this.partList = response.Data;
                  this.gridView = of({
                      data: response.Data,
                      total: response.Total ? response.Total : 0,
                  });
              } else {
                  this.toastService.error('Part not found', true);
              }
          });
  }

    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartDescription', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartCategoryId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'HotRequest', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'EngineerUserId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        // TMS-18490 Add 'Package Type' Filter in Supplier and PE 'Search Part' Screen
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PackageTypeId');
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'Demand_Status', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'WorkflowStatusId', Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'TeslaEquipmentCode', Constants.FILTER_DATATYPE_STRING, Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }

    UpdateFilterFromQueryString()
    {
        this.filterForm.controls['PartNumber'].patchValue(this.partNumber);
        this.filterForm.controls['SupplierCode'].patchValue(this.supplierCode);
        this.filterForm.controls['SourceTypeId'].patchValue(this.sourceTypeId);
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        // since display values of supplier code and business location can't be set manually, blank out partnumber too for consistency, but it's causing to remove filter so comment it
        // this.filterForm.controls['PartNumber'].patchValue('');
    }
    
    clearFilter() {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
        this.initiateState();
    }

    SearchProposals(partInfo: PartBasicInfo) {
        if (!partInfo) {
            return;
        }
        // if(!this.sourcePartInfoId)
        // {
        //   this.sourcePartInfoId = partInfoId;
        // }
        this.partInfoInContext = partInfo;
        this.getProposalClicked = true;
        const queryPartProposalsSearchDTO: QueryPartProposalsSearchDTO = new QueryPartProposalsSearchDTO();
        queryPartProposalsSearchDTO.Id = partInfo.Id;
        queryPartProposalsSearchDTO.PEId = 0;
        queryPartProposalsSearchDTO.PartNumber = partInfo.PartNumber;
        queryPartProposalsSearchDTO.SupplierCode = partInfo.SupplierCode;
        queryPartProposalsSearchDTO.UOMCode = partInfo.POUomCode;
        queryPartProposalsSearchDTO.SourceTypeId = partInfo.SourceTypeId;
        const workflowStatusId = this.filterForm.get("WorkflowStatusId").value;        
        queryPartProposalsSearchDTO.WorkflowStatusId = workflowStatusId;
        const teslaEquipmentCode = this.filterForm.get("TeslaEquipmentCode").value;        
        queryPartProposalsSearchDTO.TeslaEquipmentCode = teslaEquipmentCode;

        this.dataService
            .getProposalsForPart(queryPartProposalsSearchDTO)
            .subscribe((response: any) => {
                // this.partInfo = response
                this.scrollToBottom();
                if (response) {
                    this.proposalList = response.Data;
                    Helper.getCSSClassForProposalList(this.proposalList);
                }
            });   
    }

    initiateState() {
        this.getProposalClicked = false;
        this.partList = [];
        this.proposalList = [];
    }

    submittedBy(isTeslaUpdate) {
        if (isTeslaUpdate) {
            return 'Tesla';
        } else {
            return 'Supplier';
        }
    }

    viewProposal(id: number) {
        this.proposalService.RefreshproposalToViewId(id);
        window.open('viewproposal/' + id, '_blank');
    }
    navigateToUpdateProposal(id: number) {
        // this.router.navigate(['/proposal', id] );
        window.location.href = '/proposal/' + id;
    }
    getEffectivityFrom(dataItem: any) {
        if (dataItem) {
            // const effectivityFrom = this.pipe.transform(dataItem.EffectiveFrom, 'short');
            return Helper.formatDate(dataItem.EffectiveFrom);
        } else {
            return '';
        }
    }

    getEffectiveTo(unformattedDate: Date) {
            return Helper.getEffectiveTo(unformattedDate);
    }

    /*
    TMS-12409 While creating proposals for any searched partNumber, a check is done to 
    find if the part contains any existing proposals with new/submitted/rejected status

    Update:
    TMS-14551 Criteria for determining existing proposal
    Remove exising proposal check
    */
    createProposal(part: PartBasicInfo) {
        const selectedParts: PartBasicInfo[] = [];
        selectedParts.push(part);
        this.proposalService.RefreshpartInfoToBeCreatedList(selectedParts);
        this.router.navigate(['../', 'proposal']);
    }
    
    rejectProposal(proposal: ProposalBasicInfoDTO) {
        const updateProposalStatusDTO = new UpdateProposalStatusDTO();
        updateProposalStatusDTO.ProposalId = proposal.Id;
        updateProposalStatusDTO.RejectReasonIds = [Constants.REJECTED_REASON_ID_OTHER];
        updateProposalStatusDTO.WorkflowStatusId = Constants.WORKFLOW_STATUS_REJECTED;

        /**
         * TMS-16561 Need to prompt user to add rejection reason for already approved proposal
         * We require PE to provide rejection comments when rejecting an approved proposal.
         */
        const dialogRef = this.matDialog.open(ProposalRejectionReasonComponent, {
            height: '300px',
            width: '500px',
            data: updateProposalStatusDTO
        });

        dialogRef.afterClosed().subscribe(result => {
            if (updateProposalStatusDTO.RejectionComment) {
                this.fillGrid();
            }
        });
    }

    getProposalStatus(statusId: number) {
        return Helper.getProposalStatusDescription(statusId);
    }

    ValidatesearchPartForm() {}

    onEmptyPE(eventObj: any): void {
        this.filterForm.controls['EngineerUserId'].patchValue(null);
        this.PEAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId'), 1);
        }
    }
    onEmptySupplierCode(eventObj: any): void {
        this.filterForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
        }
    }
    isApprovedProposal(workflowStatusId: number): boolean {
        return (workflowStatusId === Constants.WORKFLOW_STATUS_APPROVED);
    }

    setSourceTypeDesc(dataItem: PartInfo){
        return  Helper.getSourceTypeToDisplay(dataItem);
    }

    deleteProposal(proposal) {
        if (Helper.confirmDeleteAction()) {
            this.dataService.deleteProposal(proposal.Id).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('Proposal deleted successfully', true);
                    this.SearchProposals(proposal);
                } else {
                    this.toastService.error(
                        'Could not delete the proposal'
                    );
                }
            });
        } else {
            this.toastService.info('You cancelled the delete request');
        }
    }

    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }
    
    hasUserEnterAnyValue() {
        const controls = this.filterForm.controls;        
        if (!controls) return true;

        const anyFieldHasValue = Object.keys(controls).some(key => controls[key].value);
        return anyFieldHasValue;
    }

    localSearch() {
        this.UpdateFilter();
        this.atLeastOneFieldError = false;
        if(!this.hasUserEnterAnyValue()) {
            this.atLeastOneFieldError = true; 
            return;
        }

        this.search();
    }
}
